import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-raleway-20 t-blue mb-4 mr-3 title-section" }
const _hoisted_2 = { class: "wrapper-details delivery-addresses" }
const _hoisted_3 = { class: "delivery-details" }
const _hoisted_4 = { class: "uppercase text-raleway-13" }
const _hoisted_5 = { class: "uppercase text-raleway-13" }
const _hoisted_6 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_7 = { class: "uppercase text-raleway-13" }
const _hoisted_8 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "mt-2 mb-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

import { DeliveryDataComponentValidation } from "@/utils/validation/accauntDetailsValidation/deliveryDataComponent";
import { ChedulesDetails } from "@/store/modules/accountDetails/type";
import ShedulesComponent from "../shedules/shedulesComponent.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import { UserTypeOperation } from "@/store/modules/User/type";
import { Locations } from "@/store/modules/Locations/type";
import { Costumers } from "@/store/modules/Customers/type";
import { ShedulesFetch } from "../fetchData/shedulesFetch";
import { StockType } from "@/store/modules/Stock/type";
import { IStore } from "@/store/types/StoreType";
import SelectAddress from "./selectAddress.vue";
import { Field, useForm } from "vee-validate";
import { useStore } from "vuex";

import AddressStockComponent from "./addressStockComponent.vue";
import PhoneComponent from "@/components/phone/phoneComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'deliveryComponent',
  setup(__props) {

const store = useStore<IStore>();

const errorValues = ref();
const allErrors = ref();

watch(
  () => store.getters?.getGlobalErrorsChedulesComponent || [],
  (value) => {
    allErrors.value = value;
    errorValues.value = allErrors.value.map((value: any) =>
      Array.isArray(Object.keys(value))
        ? Object.keys(value)[0]
        : Object.keys(value)
    );
  },
  {
    deep: true,
  }
);

const initialValues = ref<ChedulesDetails>(
  store.getters.getChedulesComponentValuesAccountDetails
);
const userData = ref(
  computed<UserTypeOperation>(() => store.getters.getUserData)
);

const { errors, values, resetForm, validate, handleSubmit, setValues } =
  useForm<ChedulesDetails>({
    initialValues,
    validationSchema: DeliveryDataComponentValidation,
  });

const customerDataUser = ref(
  computed<Costumers[]>(() => store?.getters?.getUserCustomerData)
);

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));

// locations
const locations = ref(
  computed<Locations[]>(() => store.getters?.getStockLocations)
);

const errorCustomer = ref({
  error: customerDataUser.value?.length > 0 ? false : true,
  message: "Pleace, create Customer",
});

// updateOrCreate schedules and locations schedules
const onSubmit = handleSubmit.withControlled((values) => {
  if (!customerDataUser.value || customerDataUser.value?.length <= 0)
    return (errorCustomer.value.error = true);
  else errorCustomer.value.error = false;

  ShedulesFetch(
    {
      ...locations.value[0],
      ...customerDataUser.value[0],
      ...userData.value,
      locationId: customerDataUser.value[0]?.location,
      customerId: customerDataUser.value[0]?.id,
      user_phone: userData.value.phone,
    },
    initialValues.value,
    values
  ).then(() => (errorCustomer.value.error = false));
});

const stock = ref(
  computed<StockType[]>(() => store.getters?.getStockResultsInSelectedSheldules)
);
const locationSelected = ref(
  computed<Locations[]>(() => store.getters.getStockLocationsInSelectedAddress)
);

watch(
  () => [stock.value, locationSelected.value],
  () => {
    store.commit("updateAccountDetailsStock", stock.value[0]);
  }
);
watch(
  () => uiLang.value,
  () => {
    if (values.postal_code_stock || store.getters.getLocationLoading) return;
    store.commit("updatePersonalDataComponenValuesChedules");
  }
);

onBeforeMount(() => {
  store.dispatch("getStockDetails");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "wrapper-details-data",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"])),
    encType: "multipart/form-data"
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$tc("delivery_addresses")), 1),
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withMemo([
            uiLang.value,
            _unref(errors)?.buyer_name_stock,
            _unref(values)?.buyer_name_stock,
            (stock.value || [])[0]?.responsible_name,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2", { 'error-input mini': !!_unref(errors)?.buyer_name_stock }])
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tc("contact person")), 1),
          _createVNode(_unref(Field), {
            tabindex: 17,
            maxlength: "30",
            type: "text",
            name: "buyer_name_stock",
            class: "input input-mini mb-1",
            value: _unref(values)?.buyer_name_stock,
            placeholder: _ctx.$tc('contact person')
            
          }, null, 8, ["value", "placeholder"])
        ], 2)), _cache, 0),
        _withMemo([
            _unref(errors)?.buyer_phone_stock,
            _unref(values)?.buyer_phone_stock,
            _unref(values)?.buyer_phone_stock_start,
            uiLang.value,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2", { 'error-input mini': !!_unref(errors)?.buyer_phone_stock }])
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("Phone number")), 1),
          _createVNode(PhoneComponent, {
            tabindex: 18,
            class: _normalizeClass({ 'error-input_phone': !!_unref(errors)?.buyer_phone_stock }),
            value: _unref(values)?.buyer_phone_stock || '',
            placeholder: '###-###-##',
            name: 'buyer_phone_stock',
            start: _unref(values)?.buyer_phone_stock_start,
            change: 'changeStartValue_buyer_phone_stock_start'
          }, null, 8, ["class", "value", "start"])
        ], 2)), _cache, 1),
        _createVNode(AddressStockComponent, {
          errors: _unref(errors),
          values: _unref(values)
        }, null, 8, ["errors", "values"]),
        _withMemo([
            uiLang.value,
            _unref(errors)?.comment,
            _unref(values)?.comment,
            (stock.value || [])[0]?.comment,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2 mt-2", { 'error-input mini': !!_unref(errors)?.comment }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tc("Note for the delivery person")), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("(optional)")), 1)
          ]),
          _createVNode(_unref(Field), {
            value: _unref(values)?.comment,
            name: "comment"
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("textarea", _mergeProps({
                tabindex: 20,
                maxlength: "535",
                class: "select-textarea input"
              }, field, {
                name: "comment",
                placeholder: (stock.value || [])[0]?.comment || ''
              }), null, 16, _hoisted_9)
            ]),
            _: 1
          }, 8, ["value"])
        ], 2)), _cache, 2)
      ]),
      _createVNode(SelectAddress, {
        resetForm: _unref(resetForm),
        values: _unref(values),
        setValues: _unref(setValues)
      }, null, 8, ["resetForm", "values", "setValues"]),
      _createVNode(ShedulesComponent, {
        initialValues: initialValues.value,
        errors: _unref(errors),
        values: _unref(values),
        resetForm: _unref(resetForm),
        onSubmit: _unref(onSubmit)
      }, null, 8, ["initialValues", "errors", "values", "resetForm", "onSubmit"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allErrors.value, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "uppercase text-raleway-13 t-danger text-center",
          key: error
        }, [
          (typeof error === 'object')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(Object.keys(error) + ": " + Object.values(error)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(error), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, allErrors.value]
    ])
  ], 32))
}
}

})